import React from 'react';
import PropTypes from 'prop-types';
import LocationFormatter from '../_cart/location-formatter';
import genericHelpers from 'customer_pages/_utils/generic-helpers';

function extractStoreInfo(store) {
  if (!store) return {};

  const {
    name,
    storeType,
    address: { street, city, state, zipcode },
    distance,
  } = new LocationFormatter(store);

  const address = [
    street ? street + ' ' : '',
    [city, [state, zipcode].filter(Boolean).join(' ')].join(', '),
  ]
    .filter(Boolean)
    .join(' ');

  const title = `${name}, ${genericHelpers.capitalizeWordsInString(storeType)}`;
  const distanceLine =
    distance && typeof distance.miles === 'number'
      ? `${distance.miles} miles`
      : '';

  return { address, title, distanceLine };
}

const ConfirmStore = ({ currentStore = null, newStore = null, cancelChange, saveStore }) => {
  const existing = extractStoreInfo(currentStore);
  const nextStore = extractStoreInfo(newStore);

  return (
    <div className="store-picker" role="document">
      <div className="modal-clickable">
        <div className="confirmation-modal" data-test-id="confirm-store">
          <div className="modal-header-custom">
            <h2 className="h4 modal-header-title">
              <span className="warning-icon">!</span>
              Change Your Store?
            </h2>
          </div>
          <div className="modal-body">
            <p className="modal-message">
              You already have a store selected in cart. Changing your store may
              affect item availability, pricing, and delivery options for your
              cart.
            </p>
            <div className="store-comparison">
              <div className="store-item">
                <div className="store-label">Current Store</div>
                <div className="store-name">{existing.title}</div>
                <div className="store-address">{existing.address}</div>
                <div className="store-distance">{existing.distanceLine}</div>
              </div>
              <div className="store-item new-store-highlight">
                <div className="store-label">New Store</div>
                <div className="store-name">{nextStore.title}</div>
                <div className="store-address">{nextStore.address}</div>
                <div className="store-distance">{nextStore.distanceLine}</div>
              </div>
            </div>
          </div>
          <div className="modal-footer-custom">
            <button className="modal-btn btn-cancel" onClick={cancelChange}>
              Keep Current Store
            </button>
            <button className="modal-btn btn-confirm" onClick={saveStore}>
              Change Store
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmStore.propTypes = {
  currentStore: PropTypes.object,
  newStore: PropTypes.object,
  cancelChange: PropTypes.func.isRequired,
  saveStore: PropTypes.func.isRequired,
};

export default ConfirmStore;
